import EconActivity from "./econActivity";

// Días antes del vencimiento de la firma en que se empieza a avisar.
const CERTIFICATE_WARNING_DAYS = 30;

const Business = class {
    constructor(object) {
        this.contribuitorTypes = [
            {name: 'Emprendedor', value: 'Contribuyente Régimen RIMPE'},
            {name: 'Negocio Popular', value: 'Contribuyente Negocio popular Régimen RIMPE'},
            {name: 'General', value: 'Contribuyente Régimen GENERAL'}
        ]
        
        if (object === undefined) {
            this.id = null;
            this.businessType = null;
            this.registeredName = null;
            this.commercialName = null;
            this.identification = null;
            this.hasAccounting = null;
            this.makesRetention = null;
            this.certPass = null;
            this.hasCertificatePass = false;
            this.sriPortalUser = null;
            this.sriPortalPass = null;
            this.hasSriPortalCredentials = false;
            this.certName = "Seleccionar";
            this.contribuitorCode = null;
            this.contribuitorType = null;
            this.rentPercentage= null;
            this.ivaPercentage = null;
            this.defaultActivity =  null;
            this.tax = 0.0;
            this.taxPercentage = '';
            this.expiresAt = null;
            this.expiresAtDate = null;
            this.defaults = {};
            this.mainAddress = null;
            this.rucDocumentUrl = null;
        } else {
            // Lo usan claves por negocio, como la de la bienvenida de la prueba (H61).
            this.id = object.id || null;
            this.businessType = object.businessType || null;
            this.registeredName = object.registeredName || null;
            this.commercialName = object.commercialName || null;  // nombre comercial (opcional, del alta)
            this.identification = object.identification || null;
            this.hasAccounting = object.hasAccounting || null;
            this.makesRetention = object.makesRetention || null;
            // Igual que sriPortalPass: el backend nunca la envía, solo avisa si hay
            // una guardada. certPass lleva únicamente lo que el usuario escribe.
            this.certPass = null;
            this.hasCertificatePass = object.hasCertificatePass || false;
            this.sriPortalUser = object.sriPortalUser || null;
            this.sriPortalPass = null;
            this.hasSriPortalCredentials = object.hasSriPortalCredentials || false;
            this.certName = (object.certName !== undefined) ? object.certName : "Seleccionar";
            this.contribuitorCode = object.contribuitorCode || null;
            this.contribuitorType = null;
            for (var i=0; i<this.contribuitorTypes.length; i++) {
                if (object.contribuitorType===this.contribuitorTypes[i].value) {
                    this.contribuitorType = this.contribuitorTypes[i]
                } 
            }
            this.tax = object.tax || 0.12;
            this.taxPercentage = object.taxPercentage || '12';
            this.defaultActivity =  new EconActivity(object.defaultActivity);
            this.defaults = object.defaults || {};
            // Solo lectura en Negocio (H53): la dirección de la matriz y el certificado de RUC
            // que se subió en el registro. El backend manda «-» sin matriz.
            this.mainAddress = (object.mainAddress && object.mainAddress !== '-') ? object.mainAddress : null;
            this.rucDocumentUrl = object.rucDocumentUrl || null;

            if (object.expiresAt) {
                // El backend envía la fecha como DD/MM/YYYY; new Date() la interpreta
                // como MM/DD/YYYY y devuelve "Invalid Date". La parseamos a mano.
                const parts = String(object.expiresAt).split('/');
                const expiresAt = (parts.length === 3)
                    ? new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10))
                    : new Date(object.expiresAt);
                if (!isNaN(expiresAt.getTime())) {
                    const options = { year: 'numeric', month: 'long', day: 'numeric' };
                    this.expiresAt = expiresAt.toLocaleDateString('es-EC', options);
                    this.expiresAtDate = expiresAt;
                } else { this.expiresAt = null; this.expiresAtDate = null }
            } else { this.expiresAt = null; this.expiresAtDate = null }
        }
    }

    // Estado de la firma para mostrarlo junto al certificado; null si no hay
    // fecha de expiración. Se avisa con anticipación porque una firma vencida
    // deja al negocio sin poder emitir comprobantes.
    get certificateStatus() {
        if (!this.expiresAtDate) { return null }
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        // round y no floor: un cambio de horario no debe restar un día.
        const days = Math.round((this.expiresAtDate - today) / 86400000);
        if (days < 0) {
            return { severity: 'danger', label: `Vencida el ${this.expiresAt}` };
        }
        if (days === 0) {
            return { severity: 'warning', label: 'Vence hoy' };
        }
        if (days <= CERTIFICATE_WARNING_DAYS) {
            return { severity: 'warning', label: `Vence en ${days} ${days === 1 ? 'día' : 'días'} (${this.expiresAt})` };
        }
        return { severity: 'success', label: `Vigente hasta el ${this.expiresAt}` };
    }

}

export default Business